import { useMemo } from "react";
import { useDesignPropertyShortcuts } from "@/components/Canvas/hooks/useDesignPropertyShortcuts";
import { useKeyboardShortcuts } from "../core/useKeyboardShortcuts";
import { ShortcutMap } from "../core/types";

export const useFillStrokeShortcuts = () => {
  const { applyRemoveFill, applyRemoveStroke } = useDesignPropertyShortcuts();

  const shortcuts: ShortcutMap = useMemo(
    () => ({
      "alt+/": {
        handler: applyRemoveFill,
        description: "Remove fill",
      },
      "shift+/": {
        handler: applyRemoveStroke,
        description: "Remove stroke",
      },
    }),
    [applyRemoveFill, applyRemoveStroke],
  );

  useKeyboardShortcuts({ shortcuts });
};
